import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, of, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DatiDepositoGiudiziarioDTO } from '../../models/dati-deposito-giudiziario-dto';
import { RtsDTO } from '../../models/rts-dto';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';
import { DelegheService } from '../../services/deleghe-services/deleghe.service';
import { MessageService } from '../../services/message.service';

type DatiDepositoGeneric = keyof DatiDepositoGiudiziarioDTO;
// TODO: usare Record<,> per i diversi tipi di DatiDeposito

export type DatiDepositoVisibilityMask =
	{ [k in DatiDepositoGeneric]: boolean
	};

@Component(
	{
		selector: 'lib-dati-deposito'
		, templateUrl: './dati-deposito.component.html'
		, styleUrls: ['./dati-deposito.component.css']
	}
)
export class DatiDeposito<T extends DatiDepositoGiudiziarioDTO | null>
	implements OnInit, OnDestroy, AfterViewInit {

		public rst_mock: any[] = [
			{
				"codiceFiscale": "TR",
				"codiceOrdinante": "Terni",
				"dataFine": new Date('10/06/2025'),
				"dataInizio": new Date('10/06/2025'),
				"denominazioneRTS": "RTS 1",
				"provinceCompetenza": ["TR"]
			},
			{
				"codiceFiscale": "RM",
				"codiceOrdinante": "Roma",
				"dataFine": new Date('10/06/2025'),
				"dataInizio": new Date('10/06/2025'),
				"denominazioneRTS": "RTS 1",
				"provinceCompetenza": ["TR"]
			},
			{
				"codiceFiscale": "MI",
				"codiceOrdinante": "Milano",
				"dataFine": new Date('10/06/2025'),
				"dataInizio": new Date('10/06/2025'),
				"denominazioneRTS": "RTS 1",
				"provinceCompetenza": ["TR"]
			}
	]

	//TODO
	// DatiDepositoDTO
	// DatiDepositoGiudiziarioDTO
	// DatiDepositoNoEsproprioDTO

	@Input() datiDeposito: T =
		{} as T;

	@Input() visibilityMask: DatiDepositoVisibilityMask =
		{} as DatiDepositoVisibilityMask;

	// @Input()
	// listaRts$: Observable<Array<RtsDTO>>;

	@Input()
	listaRts$: Observable<Array<string>>;

	@Output()
	nextStep: EventEmitter<DatiDepositoGiudiziarioDTO> = new EventEmitter<
		DatiDepositoGiudiziarioDTO
	>();

	@Output()
	previousStep: EventEmitter<DatiDepositoGiudiziarioDTO> = new EventEmitter<
		DatiDepositoGiudiziarioDTO
	>();

	@Output()
	salvaBozza: EventEmitter<DatiDepositoGiudiziarioDTO> = new EventEmitter<
		DatiDepositoGiudiziarioDTO
	>();

	// TODO
	// @Input()
	// rts$: Observable<Array<TipologicaDTO>>;

	form: FormGroup;
	direction: string = "both-ways";
	isFinal: boolean = false;
	subscription: Subscription;

	rts$: Observable<Array<RtsDTO>>;

	_rts: Array<RtsDTO>;

	isImportoFormatoValidoOLD(valoreImporto) {
		return /^(?:[0-9]+|(?:[0-9]{1,3}\.?)+)(?:,[0-9]{1,2})?€?$/
			.test(valoreImporto);42
	}
	private currencyToNumber(s: string): number {
		return Number(s.replace(/\./g, '').replace(',', '.') || undefined);
	}

	isImportoFormatoValido(valoreImporto) {
		return /^(?:0|[1-9](?:[0-9]{0,2}\.[0-9]{3}(?:\.[0-9]{3})*|[0-9]*))(?:,[0-9]{2,2})€?$/
			.test(valoreImporto);
	}


	constructor(
		private msg: MessageService,
		private _ref: ChangeDetectorRef,
		private delegheService: DelegheService,
	) { }

	ngAfterViewInit(): void {
		this._ref.detectChanges()
	}

	ngOnInit() {

		this.form = new FormGroup(
			{
				'causale': new FormControl({ value: '', disabled: !this.visibilityMask.causale }, c => {

					if (!this.visibilityMask.causale) return {};

					return String(c.value || '').length > 0
						? {}
						: { 'required': 'Il campo è obbligatorio.' }
				})
				, 'importo': new FormControl({ value: '', disabled: !this.visibilityMask.importo }, c => {
					if (!this.visibilityMask.importo) return {};

					// return this.isImportoFormatoValido(c.value)
					return this.isImportoFormatoValido(c.value)
						? {}
						: { 'pattern': 'Formato non valido' };
				})
				, 'rts-inoltro': new FormControl({ value: '', disabled: !this.visibilityMask.codiceRtsInoltro }, c => {
					if (!this.visibilityMask.codiceRtsInoltro) return {};

					return String(c.value || '').length > 0
						? {}
						: { 'required': 'Il campo è obbligatorio.' };
				})
				, 'nota': new FormControl({ value: '', disabled: !this.visibilityMask.nota }, c => {
					if (!this.visibilityMask.nota) return {};

					// return String(c.value).trim().length > 0
					// 	? {}
					// 	: { 'required': 'Il campo è obbligatorio.' };
				})
			}
		);

		let valid: boolean = true;

		if (!this.datiDeposito) {
			this.initDatiDeposito();
			valid = false;
		}

		this._rts = this.rst_mock;
		this.listaRts$ = of(this.rst_mock);
		this.rts$ = of(this.rst_mock);
		// this.listaRts$.subscribe(
		// 	(rts) => {
		// 		console.log('[listaRts$]', rts);
		// 		if (rts != null) {
		// 			this.rts$ = this.delegheService.getListRtsCodiceRegione(rts);
		// 			this.rts$.subscribe(_rts => {
		// 				this._rts = _rts;
		// 				//console.log("_rts" + JSON.stringify(this._rts))
		// 			});
		// 		}
		// 	}
		// );

		this.form.controls['causale'].setValue(this.datiDeposito.causale);
		this.form.controls['importo'].setValue(this.datiDeposito.importo);
		this.form.controls['rts-inoltro'].setValue(this.datiDeposito.codiceRtsInoltro);
		this.form.controls['nota'].setValue(this.datiDeposito.nota);

		const changes$ = this.form.valueChanges.pipe(
			map(_ => {
				const dati = new DatiDepositoGiudiziarioDTO() as T;
				dati.causale = this.form.controls['causale'].value;
				if(this.form.controls['importo'].value != undefined){
					dati.importo = this.currencyToNumber(this.form.controls['importo'].value);
				}
				dati.codiceRtsInoltro = this.form.controls['rts-inoltro'].value;
				if(dati?.codiceRtsInoltro && this?._rts) {
					dati.denominazioneRTS = this._rts.find(x => x.codiceFiscale == dati?.codiceRtsInoltro)?.denominazioneRTS;
				}
				dati.nota = this.form.controls['nota'].value;
				this.datiDeposito = dati;
				// console.log("[dati]", this.form);
				return ComponentOutputStatus.of(
					this.form.valid, this.datiDeposito);
			}),
			startWith(ComponentOutputStatus.of(valid, this.datiDeposito))
		);

		this.subscription = changes$.subscribe(newDati =>
			console.log('[DatiDepositoComponent] datiSpecificiDeposito', newDati)
		);

	}

	forward($event: any) {
		this.nextStep.emit(this.datiDeposito);
	}

	backward($event: any) {
		this.previousStep.emit(this.datiDeposito);
	}

	onSalvaBozza($event: any) {
		this.salvaBozza.emit(this.datiDeposito);
	}

	complete($event: any) { }

	isFormValid(): boolean {
		return this.form.valid;
	}

	initDatiDeposito() {
		//TODO
		//this.datiDeposito = new DatiDepositoDTO() as T;
		this.datiDeposito = new DatiDepositoGiudiziarioDTO() as T;
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
